import React from "react";

function SaleIcon() {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.25 2.5H3.75C3.41848 2.5 3.10054 2.6317 2.86612 2.86612C2.6317 3.10054 2.5 3.41848 2.5 3.75V16.25C2.5 16.5815 2.6317 16.8995 2.86612 17.1339C3.10054 17.3683 3.41848 17.5 3.75 17.5H16.25C16.5815 17.5 16.8995 17.3683 17.1339 17.1339C17.3683 16.8995 17.5 16.5815 17.5 16.25V3.75C17.5 3.41848 17.3683 3.10054 17.1339 2.86612C16.8995 2.6317 16.5815 2.5 16.25 2.5ZM12.9422 7.94219L9.00859 11.875H11.25C11.4158 11.875 11.5747 11.9408 11.6919 12.0581C11.8092 12.1753 11.875 12.3342 11.875 12.5C11.875 12.6658 11.8092 12.8247 11.6919 12.9419C11.5747 13.0592 11.4158 13.125 11.25 13.125H7.5C7.33424 13.125 7.17527 13.0592 7.05806 12.9419C6.94085 12.8247 6.875 12.6658 6.875 12.5V8.75C6.875 8.58424 6.94085 8.42527 7.05806 8.30806C7.17527 8.19085 7.33424 8.125 7.5 8.125C7.66576 8.125 7.82473 8.19085 7.94194 8.30806C8.05915 8.42527 8.125 8.58424 8.125 8.75V10.9914L12.0578 7.05781C12.1159 6.99974 12.1848 6.95368 12.2607 6.92225C12.3366 6.89083 12.4179 6.87465 12.5 6.87465C12.5821 6.87465 12.6634 6.89083 12.7393 6.92225C12.8152 6.95368 12.8841 6.99974 12.9422 7.05781C13.0003 7.11588 13.0463 7.18482 13.0777 7.26069C13.1092 7.33656 13.1253 7.41788 13.1253 7.5C13.1253 7.58212 13.1092 7.66344 13.0777 7.73931C13.0463 7.81518 13.0003 7.88412 12.9422 7.94219Z"
          fill="#00873D"
        />
      </svg>
    </>
  );
}

export default SaleIcon;
